// deps
import React, { memo } from "react";

// internal deps
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as ArrowBack } from "@swiggy-private/dls-web-icons/dist/web/generic/arrowBack/24";

// constants
import { BILL_PAYMENT_SHIMMER_DIMENSIONS, TURBO_SHIMMER_DIMENSIONS } from "@dineout-cart-client/constants";

// styles
import {
    BackIconWrapper,
    BlockContent,
    Col,
    FixedBottomBlock,
    Line,
    PayButton,
    PaymentMethodIcon,
    PaymentMethodLine,
    Row,
    ShimmerBlock,
    ShimmerContainer,
    ShimmerContent,
    ShimmerHeader,
} from "./styles";

interface IBillPaymentShimmerProps {
    goBack: () => void;
}

const BillPaymentShimmer = ({ goBack }: IBillPaymentShimmerProps) => {
    return (
        <ShimmerContainer>
            <ShimmerHeader>
                <BackIconWrapper type="button" onClick={goBack} aria-label="Go back">
                    <GenericIcon Icon={ArrowBack} fillColor="text_Med_Emphasis" strokeColor="text_Med_Emphasis" />
                </BackIconWrapper>
            </ShimmerHeader>
            <ShimmerContent>
                <ShimmerBlock $height={BILL_PAYMENT_SHIMMER_DIMENSIONS.REWARDS_BLOCK_HEIGHT} />
                <ShimmerBlock $height={BILL_PAYMENT_SHIMMER_DIMENSIONS.POOLING_BLOCK_HEIGHT} />
                <ShimmerBlock $height={BILL_PAYMENT_SHIMMER_DIMENSIONS.COUPON_BLOCK_HEIGHT} />
                <ShimmerBlock $height={BILL_PAYMENT_SHIMMER_DIMENSIONS.BILL_DETAILS_BLOCK_HEIGHT} />
            </ShimmerContent>
            <FixedBottomBlock>
                <BlockContent>
                    <Row>
                        <Col>
                            <Row>
                                <PaymentMethodIcon
                                    $height={TURBO_SHIMMER_DIMENSIONS.ICON_HEIGHT}
                                    $width={TURBO_SHIMMER_DIMENSIONS.ICON_WIDTH}
                                />
                                <PaymentMethodLine
                                    $height={TURBO_SHIMMER_DIMENSIONS.METHOD_HEIGHT}
                                    $width={TURBO_SHIMMER_DIMENSIONS.METHOD_WIDTH}
                                />
                            </Row>
                            <Line
                                $height={TURBO_SHIMMER_DIMENSIONS.LINE_HEIGHT}
                                $width={TURBO_SHIMMER_DIMENSIONS.LINE_WIDTH}
                            />
                        </Col>
                        <Col>
                            <PayButton
                                $width={TURBO_SHIMMER_DIMENSIONS.PAY_WIDTH}
                                $height={TURBO_SHIMMER_DIMENSIONS.PAY_HEIGHT}
                            />
                        </Col>
                    </Row>
                </BlockContent>
            </FixedBottomBlock>
        </ShimmerContainer>
    );
};

export default memo(BillPaymentShimmer);
